<template lang="pug">
  .ChapterTitle(:style="{height: elHeight + 'px'}")
    .ChapterTitle_wrapper(:class="`is-sticked-${stickedPos}`")
      //- BackgroundRelief
      .ChapterTitle_title(ref="title" :style="titleStyle") {{title}}
</template>

<script>

import raf from 'raf'
import BackgroundRelief from '@/components/common/BackgroundRelief'

export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  components: {
    BackgroundRelief
  },
  data () {
    return {
      titleWidth: 0,
      stickedPos: 'top',
      scrollProgress: 0
    }
  },
  computed: {
    elHeight () {
      return this.titleWidth // la hauteur de l'élement doit être égale à la largeur du titre
    },
    titleStyle () {
      return {
        transform: `translateX(-${this.scrollProgress * 100}%)`
      }
    }
  },
  watch: {
    title () {
      this.$nextTick(this.updateTitleWidth)
    }
  },
  mounted () {
    window.addEventListener('resize', this.windowResizeHandler)
    window.addEventListener('orientationchange', this.windowResizeHandler)

    this.updateTitleWidth()

    this.startScrollRaf()
  },
  beforeDestroy () {
    this.stopScrollRaf()

    window.removeEventListener('resize', this.windowResizeHandler)
    window.removeEventListener('orientationchange', this.windowResizeHandler)
  },
  methods: {
    startScrollRaf () {
      this._scrollRaf = this.$raf.create(this.scrollRaf)
    },
    scrollRaf () {
      const elRect = this.$el.getBoundingClientRect(),
        viewportHeight = window.innerHeight

      if (elRect.top < 0 && (elRect.top + elRect.height - viewportHeight) > 0) {
        this.stickedPos = 'middle'
      } else if (elRect.top > 0) {
        this.stickedPos = 'top'
      } else {
        this.stickedPos = 'bottom'
      }

      this.scrollProgress = -elRect.top / (elRect.height - viewportHeight)

      // this._scrollRaf = raf(this.scrollRaf)
    },
    stopScrollRaf () {
      if (this._scrollRaf) {
        this.$raf.cancel(this._scrollRaf)
        this._scrollRaf = null
      }
    },
    /**
     * Update title width
     */
    updateTitleWidth () {
      this.titleWidth = this.$refs.title.getBoundingClientRect().width
    },
    /**
     * Callback lorsque la fenêtre se resize
     */
    windowResizeHandler () {
      this.updateTitleWidth()
    }
  }
}

</script>

<style lang="stylus" scoped>
  .ChapterTitle
    position: relative
    pointer-events: none
    background-color $grey-1
    // z-index 2

    &_wrapper
      display: block
      // height 'calc(100vh - %s)' % $chapterNav_height_s
      height 100vh
      display flex
      position relative
      flex-direction row
      align-items: center
      justify-content: flex-start
      position: absolute
      left 0
      // background-image url('/img/backgrounds/horizontalscrollpage_bgpattern_light.png')
      background-image url('/img/backgrounds/relief_background.jpg')
      background-repeat: no-repeat;
      background-position: center center;
      background-attachment: fixed;
      background-size: cover;

      .BackgroundRelief

        position absolute

      // @media $mq_m
      //   height 'calc(100vh - %s)' % $chapterNav_height_m

      // @media $mq_xl
      //   height 'calc(100vh - %s)' % $chapterNav_height_xl

      &.is-sticked-top,
      &.is-sticked-middle
        // top $chapterNav_height_s
        top 0px

        @media $mq_m
          // top $chapterNav_height_m
          top 0px

        @media $mq_xl
          // top $chapterNav_height_xl
          top 0px

      &.is-sticked-middle
        left $menu_bar_width_mobile
        position: fixed

        @media $mq_m
          left $menu_bar_width

      &.is-sticked-bottom
        bottom 0

    &_title
      padding: 0 0 0 100vw
      display: inline-block
      width auto
      white-space: nowrap
      font-size: 21.875vw
      line-height: 1em
      letter-spacing: 0.04em
      color $beige
      font-family: 'Sectra Display'
      transform transform

</style>
